export default __webpack_public_path__ + "static/media/Diviner's Bracers of Secret Doors.a4ecf95a.jpg";